import ajaxDelete from "./util-ajax-delete";
import ajaxGet from "./util-ajax-get";
import ajaxSave from "./util-ajax-save";
import contentDynamic from "./util-content-dynamic";
import contentStatic from "./util-content-static";
import contentUrls from "./util-content-urls";

const util = {
  deleteDropboxIntegration: ajaxDelete.deleteDropboxIntegration,
  deleteElementFromPod: ajaxDelete.deleteElementFromPod,
  deleteExceptionFromRule: ajaxDelete.deleteExceptionFromRule,
  deletePod: ajaxDelete.deletePod,
  deleteSpot: ajaxDelete.deleteSpot,
  deleteSpotFromPod: ajaxDelete.deleteSpotFromPod,
  deletePodFromCampaign: ajaxDelete.deletePodFromCampaign,
  deleteRule: ajaxDelete.deleteRule,
  deleteCampaign: ajaxDelete.deleteCampaign,
  deleteInviteFromStation: ajaxDelete.deleteInviteFromStation,
  deleteUserFromStation: ajaxDelete.deleteUserFromStation,
  deleteInvoiceCustomizations: ajaxDelete.deleteInvoiceCustomizations,

  getCampaign: ajaxGet.getCampaign,
  getCampaigns: ajaxGet.getCampaigns,
  getChangeLog: ajaxGet.getChangeLog,
  getConflicts: ajaxGet.getConflicts,
  getException: ajaxGet.getException,
  getIntegrations: ajaxGet.getIntegrations,
  getInterstitialsByDay: ajaxGet.getInterstitialsByDay,
  getInterstitialsByTimeslot: ajaxGet.getInterstitialsByTimeslot,
  getInterstitialsByWeek: ajaxGet.getInterstitialsByWeek,
  getInvoiceCustomizations: ajaxGet.getInvoiceCustomizations,
  getInvoiceDefaults: ajaxGet.getInvoiceDefaults,
  getLivestreamData: ajaxGet.getLivestreamData,
  getPod: ajaxGet.getPod,
  getPods: ajaxGet.getPods,
  getPodStatus: ajaxGet.getPodStatus,
  getPodsNotifications: ajaxGet.getPodsNotifications,
  getPodsForCampaign: ajaxGet.getPodsForCampaign,
  getReports: ajaxGet.getReports,
  getReportsCSV: ajaxGet.getReportsCSV,
  getReportsPDF: ajaxGet.getReportsPDF,
  getRoles: ajaxGet.getRoles,
  getRule: ajaxGet.getRule,
  getRules: ajaxGet.getRules,
  getS3Url: ajaxGet.getS3Url,
  getScheduleByDay: ajaxGet.getScheduleByDay,
  getScheduleByWeek: ajaxGet.getScheduleByWeek,
  getSchedulesInterstitialsCSV: ajaxGet.getSchedulesInterstitialsCSV,
  getSearchResults: ajaxGet.getSearchResults,
  getShows: ajaxGet.getShows,
  getSpot: ajaxGet.getSpot,
  getSpots: ajaxGet.getSpots,
  getSpotsForPod: ajaxGet.getSpotsForPod,
  getStation: ajaxGet.getStation,
  getStationChangeLog: ajaxGet.getStationChangeLog,
  getStationIntegrations: ajaxGet.getStationIntegrations,
  getStationInvites: ajaxGet.getStationInvites,
  getStationInvite: ajaxGet.getStationInvite,
  getStationUsers: ajaxGet.getStationUsers,
  getStationUser: ajaxGet.getStationUser,
  getUser: ajaxGet.getUser,

  saveCampaign: ajaxSave.saveCampaign,
  saveElement: ajaxSave.saveElement,
  updateElementsForPod: ajaxSave.updateElementsForPod,
  saveException: ajaxSave.saveException,
  saveFileToS3: ajaxSave.saveFileToS3,
  saveInvite: ajaxSave.saveInvite,
  saveInvoiceCustomizations: ajaxSave.saveInvoiceCustomizations,
  savePod: ajaxSave.savePod,
  savePodToCampaign: ajaxSave.savePodToCampaign,
  saveSpot: ajaxSave.saveSpot,
  saveSpotsToPod: ajaxSave.saveSpotsToPod,
  saveRule: ajaxSave.saveRule,
  saveRuleAsExpired: ajaxSave.saveRuleAsExpired,
  saveStation: ajaxSave.saveStation,
  savePodNotification: ajaxSave.savePodNotification,

  renderModal: contentDynamic.renderModal,
  renderShowsNames: contentDynamic.renderShowsNames,
  returnCleanTimeSlot: contentDynamic.returnCleanTimeSlot,
  returnCleanTimeSlots: contentDynamic.returnCleanTimeSlots,
  returnShowNames: contentDynamic.returnShowNames,
  returnLineNumber: contentDynamic.returnLineNumber,
  returnChangeLogPath: contentDynamic.returnChangeLogPath,
  returnPaginationUrl: contentDynamic.returnPaginationUrl,
  returnPodStatus: contentDynamic.returnPodStatus,
  returnSpotStatus: contentDynamic.returnSpotStatus,
  returnRepeatValue: contentDynamic.returnRepeatValue,
  returnSimpleSelectOptions: contentDynamic.returnSimpleSelectOptions,
  returnSimpleSelectOptionsForShows:
    contentDynamic.returnSimpleSelectOptionsForShows,
  returnSimpleSelectOptionsForSpots:
    contentDynamic.returnSimpleSelectOptionsForSpots,
  returnSortClass: contentDynamic.returnSortClass,
  returnSortValue: contentDynamic.returnSortValue,
  returnSunday: contentDynamic.returnSunday,
  alertInfo: contentDynamic.alertInfo,
  alertPodInfo: contentDynamic.alertPodInfo,
  formatVideoError: contentDynamic.formatVideoError,

  dateFormatComputer: contentStatic.dateFormatComputer,
  dateFormatHumanLong: contentStatic.dateFormatHumanLong,
  dateFormatHumanShort: contentStatic.dateFormatHumanShort,
  dateFormatRangeLong: contentStatic.dateFormatRangeLong,
  dateFormatRangeShort: contentStatic.dateFormatRangeShort,
  delayForm: contentStatic.delayForm,
  delayDetail: contentStatic.delayDetail,
  delayList: contentStatic.delayList,
  days: contentStatic.days,
  objectTypes: contentStatic.objectTypes,
  podStatuses: contentStatic.podStatuses,
  spotStatuses: contentStatic.podStatuses, // uses the podStatuses (they are the same)
  podElementFields: contentStatic.podElementFields,
  timeSlots: contentStatic.timeSlots,
  podResultsPerPage: contentStatic.podResultsPerPage,
  spotResultsPerPage: contentStatic.spotResultsPerPage,
  campaignResultsPerPage: contentStatic.campaignResultsPerPage,
  changeLogResultsPerPage: contentStatic.changeLogResultsPerPage,
  inviteResultsPerPage: contentStatic.inviteResultsPerPage,
  reportsResultsPerPage: contentStatic.reportsResultsPerPage,
  ruleResultsPerPage: contentStatic.ruleResultsPerPage,
  daysPerTimeSlotPerPage: contentStatic.daysPerTimeSlotPerPage,
  userResultsPerPage: contentStatic.userResultsPerPage,
  podFormDefaultSourceFile: contentStatic.podFormDefaultSourceFile,
  podFormMaxFilesize: contentStatic.podFormMaxFilesize,
  podFormMinDuration: contentStatic.podFormMinDuration,
  podFormMaxDuration: contentStatic.podFormMaxDuration,
  spotFormDefaultSourceFile: contentStatic.spotFormDefaultSourceFile,
  spotFormMaxFilesize: contentStatic.spotFormMaxFilesize,
  zeroPodsMessage: contentStatic.zeroPodsMessage,
  zeroSpotsMessage: contentStatic.zeroSpotsMessage,
  zeroCampaignsMessage: contentStatic.zeroCampaignsMessage,
  zeroLogsMessage: contentStatic.zeroLogsMessage,
  zeroReportsMessage: contentStatic.zeroReportsMessage,
  zeroRulesMessage: contentStatic.zeroRulesMessage,
  zeroExceptionsMessage: contentStatic.zeroExceptionsMessage,
  zeroInvitesMessage: contentStatic.zeroInvitesMessage,
  zeroUsersMessage: contentStatic.zeroUsersMessage,
  zeroStationsMessage: contentStatic.zeroStationsMessage,

  returnCampaignListUrl: contentUrls.returnCampaignListUrl,
  returnCampaignDetailUrl: contentUrls.returnCampaignDetailUrl,
  returnCampaignFormUrl: contentUrls.returnCampaignFormUrl,
  returnChangeLogListUrl: contentUrls.returnChangeLogListUrl,
  returnChangeLogDetailUrl: contentUrls.returnChangeLogDetailUrl,
  returnConflictFormUrl: contentUrls.returnConflictFormUrl,
  returnInviteListUrl: contentUrls.returnInviteListUrl,
  returnInviteFormUrl: contentUrls.returnInviteFormUrl,
  returnLivestreamUrl: contentUrls.returnLivestreamUrl,
  returnPodListUrl: contentUrls.returnPodListUrl,
  returnPodDetailUrl: contentUrls.returnPodDetailUrl,
  returnSpotDetailUrl: contentUrls.returnSpotDetailUrl,
  returnPodFormUrl: contentUrls.returnPodFormUrl,
  returnReportsUrl: contentUrls.returnReportsUrl,
  returnRuleListUrl: contentUrls.returnRuleListUrl,
  returnRuleDetailUrl: contentUrls.returnRuleDetailUrl,
  returnRuleFormUrl: contentUrls.returnRuleFormUrl,
  returnScheduleWeekUrl: contentUrls.returnScheduleWeekUrl,
  returnScheduleDayUrl: contentUrls.returnScheduleDayUrl,
  returnScheduleTimeSlotUrl: contentUrls.returnScheduleTimeSlotUrl,
  returnSettingsUrl: contentUrls.returnSettingsUrl,
  returnSpotFormUrl: contentUrls.returnSpotFormUrl,
  returnSpotListUrl: contentUrls.returnSpotListUrl,
  returnUserListUrl: contentUrls.returnUserListUrl,
  returnUserFormUrl: contentUrls.returnUserFormUrl,

  putFoucsOnError: () => {
    let element = document.querySelector(
      `.has-error input, .has-error select, .has-error textarea`
    );
    if (element !== null) {
      element.focus();
    }
  },

  spotsAvailable: () => {
    if (window._config !== undefined) {
      return window._config.spotsAvailable.toLowerCase() === "true";
    }
  }
};

export default util;
